import script from "./CreateProductModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateProductModal.vue?vue&type=script&setup=true&lang=js"

import "./CreateProductModal.vue?vue&type=style&index=0&id=2a837bdc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a837bdc"]])

export default __exports__